import { useState } from 'react';
import { exportToExcel } from '../helpers/excelExport';

export const useExcelExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  const exportData = async (data, filename = 'circulation-log', servicePointsMap = {}, translations = {}, selectedColumns = [], columnMapping = {}) => {
    if (!data || data.length === 0) {
      setExportError('No data to export');
      return;
    }

    setIsExporting(true);
    setExportError(null);

    try {
      const result = await exportToExcel(data, filename, servicePointsMap, translations, selectedColumns, columnMapping);
      
      if (!result.success) {
        setExportError(result.error);
      }
      
      return result;
    } catch (error) {
      setExportError(error.message);
      return { success: false, error: error.message };
    } finally {
      setIsExporting(false);
    }
  };

  const clearError = () => setExportError(null);

  return {
    exportData,
    isExporting,
    exportError,
    clearError,
  };
};